import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Icon, Form, Input, Button } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ReactTableFilterAzSearch.css';
const cx = classNames.bind(styles);

class ReactTableFilterAzSearch extends PureComponent {
  constructor(props) {
    super(props);

    // input 텍스트를 state 로 구현하는 경우 pending 오류가 발생할 수 있어 변수 입력으로 구현
    this.beforeSubmitText = '';
    this.searchText = props.filter ? props.filter.value : '';

    this.state = { clearable: false };
  }

  handleOnChangeFilter = e => {
    if (this.beforeSubmitText !== this.searchText) {
      this.props.onChange(this.searchText);
      this.beforeSubmitText = this.searchText;
    }
  };

  handleRecordChange = value => {
    const { clearable } = this.state;

    this.searchText = value;

    if (this.searchText !== '') {
      if (!clearable) {
        this.setState({ clearable: true });
      }
    } else {
      if (clearable) {
        this.setState({ clearable: false });
      }
    }
  };

  handleResetFilter = e => {
    this.searchText = '';
    this.inputSearchRef.value = '';

    if (this.beforeSubmitText !== '') {
      this.props.onChange('');
      this.beforeSubmitText = '';
    }

    this.setState({ clearable: false });
  };

  handleKeyPress = e => {
    const { name, value } = e.target;

    if (e.key.toLowerCase() === 'enter') {
      this.handleOnChangeFilter();
    }
  };

  render() {
    const { clearable } = this.state;
    const { filter, onChange } = this.props;
    const { handleKeyPress, handleOnChangeFilter, handleResetFilter, handleRecordChange } = this;

    return (
      <div className={cx('react-table-filter-as-search-area')}>
        <Input
          icon={clearable}
          type="text"
          action
          fluid
          size="mini"
          placeholder={filter ? filter.value : 'Search...'}
          onChange={e => handleRecordChange(e.target.value)}
          onKeyPress={handleKeyPress}
          defaultValue={filter ? filter.value : this.searchText}>
          <input ref={ref => (this.inputSearchRef = ref)} />
          {clearable && (
            <Icon
              size="mini"
              name="remove circle"
              onClick={handleResetFilter}
              link
              className={cx('narrow-mini-icon')}
            />
          )}
        </Input>
        <Button
          attached="right"
          className="narrow-mini-button"
          name="applyFilter"
          size="mini"
          color="blue"
          icon="search"
          onClick={handleOnChangeFilter}
        />
      </div>
    );
  }
}

export default ReactTableFilterAzSearch;



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTableFilterAzSearch.js